import { create } from "zustand";
import { MyTasksStoreProps } from "./interface/my-tasks.interface";
import { getMyTasks } from "src/services/my-tasks.service";

export const myTasksStore = create<MyTasksStoreProps>((set) => ({
  loading: false,
  data: null,
  error: null,
  getMyTasks: async () => {
    set(() => ({ loading: true }));
    try {
      const res = await getMyTasks();
      const rawData = res.data?.data || {};

      Object.keys(rawData.approvalReport).forEach((inventoryKey) => {
        Object.keys(rawData.approvalReport[inventoryKey]).forEach((yearKey) => {
          if (rawData.approvalReport[inventoryKey][yearKey].length === 0) {
            delete rawData.approvalReport[inventoryKey][yearKey];
          }
        });
      });

      set(() => ({ loading: false, data: rawData }));
    } catch (err: any) {
      set(() => ({ loading: false, error: err?.message, data: null }));
    }
  },
}));
